<div class="page-head-section">
    <p>Executive Committee <span style="font-size: 12px;">(Jan 2024 - Jan 2028)</span></p>
  </div>
  
  <div class="archers-content">
    <div class="ui-g archer-head-row">
      <div class="ui-g-3">
        <p class="heading-archer" style="text-align: left;">Name</p>
      </div>
      <div class="ui-g-4">
        <p class="heading-archer">Designation</p>
      </div>
      <div class="ui-g-5">
        <p class="heading-archer">Address</p>
      </div>
   
    </div>
  
    <div *ngFor="let data of CommitteData" class="ui-g archer-content-row">
      <div class="ui-g-3">
        <div class="player-name" style="text-align: left;">
          <!-- <img src="assets/icons/player.png" alt="" /> -->
  
          <img
          *ngIf="
            data?.photo !== '' ||
            data?.photo !== null
          "
          class="profile-img"
          [src]="global.basePathImage + data?.photo"
          alt=""
        />
  
        <img
          *ngIf="
            data?.photo ==='' ||
            data?.photo === null
          "
          class="profile-img"
          src="assets/icons/player.png"
          alt=""
        />
  
          <p class="content-archer" >{{data?.name}}</p>
        </div>
      </div>
      <div class="ui-g-4">
        <p class="content-archer">{{data?.designation}}</p>
      </div>
      <div class="ui-g-5">
        <p class="content-archer">{{ data?.address }}</p>
      </div>
    </div>
  </div>
  